export default __webpack_public_path__ + "static/media/car_front_ok.b83b901f.svg";